
import React from "react";

const AlertModal = ({ message, onClose }) => {
  
  return (
    <div className="alert-modal">
      <div className="alert-box">
        <p>{message}</p>
        <button onClick={onClose}>확인</button>
      </div>
    </div>
  );
};

export default AlertModal;